import { render, staticRenderFns } from "./WaybillAttachment.vue?vue&type=template&id=1674514c&scoped=true&"
import script from "./WaybillAttachment.vue?vue&type=script&lang=js&"
export * from "./WaybillAttachment.vue?vue&type=script&lang=js&"
import style0 from "./WaybillAttachment.vue?vue&type=style&index=0&id=1674514c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1674514c",
  null
  
)

export default component.exports